import { ActionReducerMap } from '@ngrx/store';
import { storeReducer, StoreState } from './store.reducer';
import { categoryReducer, CategoryState } from './category.reducer';
import { productReducer, ProductState } from './product.reducer';
import { orderTypeReducer, OrderTypeState } from './order-type.reducer';
import { localChannelReducer, LocalChannelState } from './local-channel.reducer';
import { subcategoryReducer, SubcategoryState } from './subcategory.reducer';
import { authReducer, AuthState } from './auth.reducer';
import { statusReducer, StatusState } from './status.reducer';
import { checkoutReducer, CheckoutState } from './checkout.reducer';
import { cartReducer, CartState } from './cart.reducer';
import { payReducer, PayState } from './pay.reducer';
import { creditCardVaultReducer, CreditCardVaultState } from './credit-card-vault.reducer';
import { coreReducer, CoreState } from './core.reducer';
import { tipReducer, TipState } from './tip.reducer';
import { workDayReducer, WorkDayState } from './work-day.reducer';
import { taxReducer, TaxState } from './tax.reducer'
import { clientReducer, ClientState } from './client.reducer'
import { deliveryZoneCustomerReducer, DeliveryZoneCustomerState } from './delivery-zone-customer.reducer';
import { deliveryZoneReducer, DeliveryZoneState } from './delivery-zone.reducer';
import { availabilityReducer, AvailabilityState } from './availability.reducer';
import { menuReducer, MenuState } from './menu.reducer';
import { couponReducer, CouponState } from './coupon.reducer';
import { specialPriceReducer, SpecialPriceState } from './special-price.reducer';
import { ConfiguracionCanalReducer, ConfiguracionCanalState } from './channel-setting.reducer';
import { storeArgentinaReducer, StoreArgentinaState } from './store-argentina.reducer';   
import { dualPricingReducer, DualPricingState } from './dual-pricing.reducer';  

export { storeReducer, StoreState } from './store.reducer';
export { categoryReducer, CategoryState } from './category.reducer';
export { productReducer, ProductState } from './product.reducer';
export { orderTypeReducer, OrderTypeState } from './order-type.reducer';
export { localChannelReducer, LocalChannelState } from './local-channel.reducer';
export { subcategoryReducer, SubcategoryState } from './subcategory.reducer';
export { authReducer, AuthState } from './auth.reducer';
export { statusReducer, StatusState } from './status.reducer';
export { checkoutReducer, CheckoutState } from './checkout.reducer';
export { cartReducer, CartState } from './cart.reducer';
export { payReducer, PayState } from './pay.reducer';
export { creditCardVaultReducer, CreditCardVaultState } from './credit-card-vault.reducer';
export { coreReducer, CoreState } from './core.reducer';
export { tipReducer, TipState } from './tip.reducer';
export { workDayReducer, WorkDayState } from './work-day.reducer';
export { taxReducer, TaxState } from './tax.reducer'
export { clientReducer, ClientState } from './client.reducer'
export { deliveryZoneCustomerReducer, DeliveryZoneCustomerState } from './delivery-zone-customer.reducer';
export { deliveryZoneReducer, DeliveryZoneState } from './delivery-zone.reducer';
export { availabilityReducer, AvailabilityState } from './availability.reducer';
export { menuReducer, MenuState } from './menu.reducer';
export { couponReducer, CouponState } from './coupon.reducer'
export { specialPriceReducer, SpecialPriceState } from './special-price.reducer'
export { ConfiguracionCanalReducer, ConfiguracionCanalState } from './channel-setting.reducer';
export { storeArgentinaReducer, StoreArgentinaState } from './store-argentina.reducer';     
export { dualPricingReducer, DualPricingState } from './dual-pricing.reducer';  

export interface AppState {
    store: StoreState,
    category: CategoryState,
    orderType: OrderTypeState,
    product: ProductState,
    localChannel: LocalChannelState,
    subcategory: SubcategoryState,
    auth: AuthState,
    status: StatusState,
    checkout: CheckoutState,
    cart: CartState,
    pay: PayState,
    creditCardVault: CreditCardVaultState,
    core: CoreState,
    tip: TipState,
    workDay: WorkDayState,
    tax: TaxState,
    client: ClientState,
    deliveryZoneCustomer: DeliveryZoneCustomerState,
    deliveryZone: DeliveryZoneState,
    availability: AvailabilityState,
    menu: MenuState,
    coupon: CouponState,
    specialPrice: SpecialPriceState,
    ConfiguracionCanal: ConfiguracionCanalState,
    storeArgentina: StoreArgentinaState,
    dualPricing: DualPricingState
}

export const reducers: ActionReducerMap<AppState> = {
    store: storeReducer,
    category: categoryReducer,
    orderType: orderTypeReducer,
    product: productReducer,
    localChannel: localChannelReducer,
    subcategory: subcategoryReducer,
    auth: authReducer,
    status: statusReducer,
    checkout: checkoutReducer,
    cart: cartReducer,
    pay: payReducer,
    creditCardVault: creditCardVaultReducer,
    core: coreReducer,
    tip: tipReducer,
    workDay: workDayReducer,
    tax: taxReducer,
    client: clientReducer,
    deliveryZoneCustomer: deliveryZoneCustomerReducer,
    deliveryZone: deliveryZoneReducer,
    availability: availabilityReducer,
    menu: menuReducer,
    coupon: couponReducer,
    specialPrice: specialPriceReducer,
    ConfiguracionCanal: ConfiguracionCanalReducer,
    storeArgentina: storeArgentinaReducer,
    dualPricing: dualPricingReducer
}
